function parseUserInfo() {
    const raw = localStorage.getItem('userInfo');
    if (!raw) {
        return {};
    }
    try {
        const data = JSON.parse(raw);
        return data && typeof data === 'object' ? data : {};
    } catch (e) {
        return {};
    }
}

function firstDefined() {
    for (let i = 0; i < arguments.length; i++) {
        const value = arguments[i];
        if (value !== undefined && value !== null && value !== '') {
            return value;
        }
    }
    return '';
}

function menuMeta(menu) {
    return menu && menu.meta ? menu.meta : {};
}

function normalizeMenu(menu, fallbackPath) {
    const meta = menuMeta(menu);
    return {
        menuId: firstDefined(meta.menuId, menu && menu.menuId, menu && menu.id),
        title: firstDefined(meta.title, menu && menu.name, menu && menu.title),
        path: firstDefined(fallbackPath, menu && menu.linkage, menu && menu.path, meta.path),
        component: firstDefined(meta.component, menu && menu.component)
    };
}

function numericValue(value) {
    const numberValue = Number(value);
    return Number.isFinite(numberValue) ? numberValue : undefined;
}

export function buildMenuTrackingPayload(options) {
    const userInfo = parseUserInfo();
    const current = normalizeMenu(options.menu || {}, options.path);
    const parent = normalizeMenu(options.parentMenu || {}, options.parentPath);
    const operatorId = firstDefined(userInfo.id, userInfo.userId);
    const operatorName = firstDefined(userInfo.nickName, userInfo.userName, userInfo.username, userInfo.name);
    const payload = {
        eventId: 600,
        caseNo: current.menuId,
        extStr: current.title,
        extType: options.source === 'top' ? 'top-menu' : 'side-menu',
        extFlag: Boolean(operatorId || operatorName),
        remark: '菜单埋点',
        trackingSource: options.source || '',
        menuId: current.menuId,
        menuTitle: current.title,
        menuPath: current.path,
        menuComponent: current.component,
        parentMenuId: parent.menuId,
        parentMenuTitle: parent.title,
        parentMenuPath: parent.path,
        operatorId,
        operatorName,
        tenantId: firstDefined(userInfo.tenantId),
        currentTenantId: firstDefined(userInfo.currentTenantId),
        batchId: firstDefined(userInfo.batchId),
        companyId: firstDefined(userInfo.company, userInfo.companyId)
    };
    const extVal = numericValue(current.menuId);
    if (extVal !== undefined) {
        payload.extVal = extVal;
    }
    return payload;
}
